// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB0pe7CF5rd039P-rpuPGBScmm60TI7Ngs",
  authDomain: "techwithanirudh12.firebaseapp.com",
  projectId: "techwithanirudh12",
  storageBucket: "techwithanirudh12.appspot.com",
  messagingSenderId: "812333956131",
  appId: "1:812333956131:web:cdfc4cb70380703a5f4596",
  measurementId: "G-KZMCPEQ1WW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);